import React from 'react';
import { Stars } from '../Stars';
import { SectionHeading } from '../SectionHeading';
import { heroTestimonials } from '../../data/landing';
export function Testimonials() {
  return <section className="bg-brand-soft px-5 py-16 md:py-24" aria-labelledby="testimonios" data-id="element-242" data-mp="3mh2adt3b3cf2">
      <div className="mx-auto max-w-6xl" data-id="element-243" data-mp="3r7irbn6c5g66">
        <div id="testimonios" data-id="element-244" data-mp="3r8amiww0tbvx">
          <SectionHeading eyebrow="Testimonios" title="Ellos ya comen sin miedo." data-id="element-245" data-mp="3r9lpiuhn6flz" />
        </div>
        <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-246" data-mp="3agab2ha8jk">
          {heroTestimonials.map(t => <figure key={t.author} className="flex flex-col rounded-3xl bg-white p-7 shadow-sm" data-id="element-247" data-mp="44w1cjp61t4u">
              <div className="flex items-center gap-3" data-id="element-248" data-mp="8zt6hfjbricg">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand text-base font-black text-white" data-id="element-249" data-mp="dzxstm6wz7al">
                  {t.initials}
                </span>
                <Stars data-id="element-250" data-mp="2frka2w107ntv" />
              </div>
              <blockquote className="mt-5 text-lg font-medium leading-relaxed text-charcoal" data-id="element-251" data-mp="2fslx7yvao0ry">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-auto pt-6 text-sm font-bold text-brand" data-id="element-252" data-mp="1ntasd9gx524m">
                — {t.author}, <span className="font-medium text-muted" data-id="element-253" data-mp="1iu7xuiykeeaw">{t.meta}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}